import { render, staticRenderFns } from "./vuePath.vue?vue&type=template&id=c5ce3a34&scoped=true"
import script from "./vuePath.vue?vue&type=script&lang=js"
export * from "./vuePath.vue?vue&type=script&lang=js"
import style0 from "./vuePath.vue?vue&type=style&index=0&id=c5ce3a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ce3a34",
  null
  
)

export default component.exports